/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { Stack, IconButton } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import EditIcon from '@material-ui/icons/Edit';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import permissionAuth from 'src/utils/permissionAuth';

export default function ProductCategoryListing(props) {
    const screenCode = 'PRODUCTCATEGORY';
    let encrypted = "";
    const navigate = useNavigate();

    const [productCategoryList, setProductCategoryList] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(getproductcategories());
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCATEGORY');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
    }

    async function getproductcategories() {
        var productCategoryList = await services.GetProductCategoties()
        setProductCategoryList(productCategoryList)
    }

    function handleClick(datas) {
        encrypted = AESEncryptionParam(datas.productCategoryID.toString());
        navigate('/dashboard/productcategory/addedit/' + encrypted)
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Product Category |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/productcategory/addedit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Product Categories"
                    />
                    <br /><Divider variant="middle" /><br />
                    {productCategoryList.length == 0 ?
                        <SearchNotFound searchQuery="Product Categories" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Category Code</TableCell>
                                                <TableCell align="center">Category Name</TableCell>
                                                <TableCell align="center">IsActive</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {productCategoryList.map((row) => (
                                                <TableRow key={row.categoryCode}>
                                                    <TableCell align="center">
                                                        {row.categoryCode}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.productCategoryName}
                                                    </TableCell>
                                                    <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete"
                                                        onClick={(e) => handleClick(row)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}